import { render } from "./TagEditor.vue?vue&type=template&id=6ec4f3ec"
import script from "./TagEditor.vue?vue&type=script&lang=js"
export * from "./TagEditor.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__